import { apiClient } from "../../lib/apiClient";
import type { SelfRegistrationListPage, SelfRegistrationRequest } from "./types";

const DEFAULT_PAGE_SIZE = 25;

export async function fetchSelfRegistrationRequests(
  status: "pending" | "approved" | "denied" = "pending",
  options?: { limit?: number; offset?: number }
): Promise<SelfRegistrationListPage> {
  const limit = options?.limit ?? DEFAULT_PAGE_SIZE;
  const offset = options?.offset ?? 0;
  const response = await apiClient.get<SelfRegistrationListPage>(
    `/self-registration/requests?status=${encodeURIComponent(status)}&limit=${encodeURIComponent(
      String(limit)
    )}&offset=${encodeURIComponent(String(offset))}`
  );
  return response.data;
}

export async function approveSelfRegistrationRequest(requestId: string) {
  const response = await apiClient.post<SelfRegistrationRequest>(
    `/self-registration/requests/${encodeURIComponent(requestId)}/approve`
  );
  return response.data;
}

export async function denySelfRegistrationRequest(
  requestId: string,
  body?: { message_to_requester?: string | null; decision_reason?: string | null }
) {
  const response = await apiClient.post<SelfRegistrationRequest>(
    `/self-registration/requests/${encodeURIComponent(requestId)}/deny`,
    body ?? {}
  );
  return response.data;
}

